import {InstanceNotificationModel} from "./../models/instance.model";
import {TranslateService} from "./../../shared/translate/translate.service";
import {AuthService} from "./../../shared/models/auth.service";
import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {InstanceModel} from "../models/instance.model";
import {InstanceService} from "../models/instance.service";
import {CustomerService} from "../../customer/models/customer.service";
import {
  ApplicationRouteURL,
  Entity,
  IAPIResponse,
  IKeyValueInterface,
  Marker,
  Permission,
  PermissionType,
  PreferredLanguage,
  RoleLevel,
  WeGoConfig
} from "../../shared/config";
import {Location} from "@angular/common";
import {FileUploader} from "ng2-file-upload";
import {DropdownModel} from "../../report/models/report-filter.model";
import {PrePostTripQuestionComponent} from "../../pre-post-trip-question/components/pre-post-trip-question.component";
import {BasePermissionModel} from "../../shared/models/base-permission-model";
import {ValidateLicense24IdCheckOption} from "../models/validate-license-24idcheck-option";
import {ImportConnectionTypeOption} from "../models/import-connectiontype-option";
import {PaymentProvider} from "../../company/models/payment-provider";
import { SharedVehicleGroupModel } from "../../sharedvehiclegroup/models/sharedvehiclegroup.model";
import { SubscriptionDropDownModel } from "../../organizationsubscription/models/organization-subscription.model";
import { ThrowStmt } from "@angular/compiler/src/output/output_ast";


@Component({
  selector: "wego-instance",
  template: require('../views/instance-update.component.html'),
  providers: [InstanceService, CustomerService],
  styles: [
    `
  .batchuploadpadding{
    padding-left: 35px;
    margin-top:10px;
  }

  .bookingDelaymargintop
  {
    margin-top: 15px;
  }

  `
  ]
})
export class InstanceUpdateComponent implements OnInit, OnDestroy {
  basePermissionModel: BasePermissionModel;
  instanceHashId: string;
  sub: any;
  public model: InstanceModel;
  apiResponse: IAPIResponse;
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  apiSvgErrorMsg: string;
  apiOrgErrorMsg: string;
  apiSubErrorMsg: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlInstanceList: string;
  dayofWeekList: any;
  damageImageExtentions: any;
  public headers: any = this.authService.GetHeaderForFile();
  public uploader: FileUploader = new FileUploader({
    url: WeGoConfig.API_POST_INSTANCE_DETAIL,
    headers: this.headers
  });
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  isLoading: boolean;
  customerList: DropdownModel[];
  ImageExtArray: string[];
  currencyAbbreviationList: any;
  preferredLanguageList: any;
  timeZoneList: DropdownModel[];
  countryList: DropdownModel[];
  markerInfo: Marker;
  roleLevel = RoleLevel;
  preferredLanguage = PreferredLanguage;
  public isAuthorizedForPrePostTrip: boolean;

  organizationList: DropdownModel[];
  sharedVehicleGroupList: SharedVehicleGroupModel[];
  subscriptionList: SubscriptionDropDownModel[];
  sharedVehicleGroupHashID: string;
  organizationHashID: string;
  subscriptionHashID: string;
  public isSvgSelected: boolean = false;
  public isOrgSelected: boolean = false;
  
  @ViewChild("logoFile") public logoFile: any;
  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("TwoFasuccessPopup") public TwoFasuccessPopup: any;
  @ViewChild("geoLocationModal") public geoLocationModal: any;
  @ViewChild("prePostTripQuestionSection")
  public prePostTripQuestionSection: PrePostTripQuestionComponent;
  popupTitle: string;

  private validateLicense24IdCheckOption = ValidateLicense24IdCheckOption;
  private validateLicense24IdCheckOptionKeys = Object.keys(ValidateLicense24IdCheckOption).filter(
      (type) => isNaN(<any>type) && type !== 'values'
  );

  private importConnectionTypeOption = ImportConnectionTypeOption;
  private importConnectionTypeOptionKeys = Object.keys(ImportConnectionTypeOption).filter(
      (type) => isNaN(<any>type) && type !== 'values'
  );

  constructor(
    private instanceService: InstanceService,
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private locationService: Location,
    private customerService: CustomerService,
  ) { }

  ngOnInit() {
    this.dayofWeekList = [
      {
        Key: this.translate.instant("LblSelectDayOfWeek"),
        Value: ""
      },
      {
        Key: this.translate.instant("LblSunday"),
        Value: "0"
      },
      {
        Key: this.translate.instant("LblMonday"),
        Value: "1"
      },
      {
        Key: this.translate.instant("LblTuesday"),
        Value: "2"
      },
      {
        Key: this.translate.instant("LblWednesday"),
        Value: "3"
      },
      {
        Key: this.translate.instant("LblThursday"),
        Value: "4"
      },
      {
        Key: this.translate.instant("LblFriday"),
        Value: "5"
      },
      {
        Key: this.translate.instant("LblSaturday"),
        Value: "6"
      }
    ];

    this.damageImageExtentions = [
      {
        Key: "JPG",
        Value: ".JPG",
        IsChecked: false
      },
      {
        Key: "GIF",
        Value: ".GIF",
        IsChecked: false
      },
      {
        Key: "PNG",
        Value: ".PNG",
        IsChecked: false
      },
      {
        Key: "JPEG",
        Value: ".JPEG",
        IsChecked: false
      },
      {
        Key: "MAC",
        Value: ".MAC",
        IsChecked: false
      },
      {
        Key: "PBM",
        Value: ".PBM",
        IsChecked: false
      },
      {
        Key: "PCD",
        Value: ".PCD",
        IsChecked: false
      }
    ];
    
    this.currencyAbbreviationList = WeGoConfig.CURRENCY_ABBREVIATION;
    this.preferredLanguageList = WeGoConfig.PREFERRED_LANGUAGE; // this.preferredLanguage;

    this.GetTimeZoneList();
    this.GetTelephoneCountry();

    this.module = this.translate.instant("LblInstance");
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlInstanceList = this.authService.GetURL(
      ApplicationRouteURL.URL_INSTANCE_LIST
    );
    this.ImageExtArray = [];
    this.model = new InstanceModel();

    this.sub = this.activeRoute.params.subscribe(params => {
      this.instanceHashId = params["id"] || "";
      if (this.instanceHashId != "") {
        this.isEditMode = true;
        this.instanceService.GetInstanceByHashId(this.instanceHashId).subscribe(
          res => {
            this.model = res.data;
            if (
              this.model != null &&
              this.model.damageImageExtensions != null
            ) {
              this.SetImageExtensionOnEdit();
            }
            if (this.model.afasToken != null) {
              this.model.afasToken = this.Base64Decode(this.model.afasToken);
            }
            this.GetSharedVehicleGroupList();
            this.GetOrganizationList();
            this.GetSubscriptionList();
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
      } else {
        this.isEditMode = false;
        this.SetImageExtensionOnAdd();

        this.model = new InstanceModel();
        this.model.odometerConfigurationModel.enabled = "NO";
        this.model.twoFAConfig.enabled = "NO";
      }
      this.GetCustomerList();
   
    });
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant("LblEditPage", [this.module])
      : this.translate.instant("LblAddPage", [this.module]);
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
    this.IsAuthorizedForPrePostTripQuestion();
  }

  ngAfterViewInit() {
    // viewChild is set after the view has been initialized
    // this.prePostTripQuestionSection.GetPrePostTripQuestionList(
    //   this.instanceHashId,
    //   null,
    //   null,
    //   null
    // );
  }

  public show(): void {
    this.apiSvgErrorMsg = '';
    this.apiOrgErrorMsg = '';
    this.apiSubErrorMsg = '';
  }

  public SetImageExtensionOnEdit() {
    var extensionArray = this.model.damageImageExtensions.split(",");
    for (let i = 0; i < extensionArray.length; i++) {
      var objIndex = this.damageImageExtentions.findIndex(
        (x: any) => x.Value == extensionArray[i]
      );
      this.damageImageExtentions[objIndex].IsChecked = true;
      this.ImageExtArray.push(this.damageImageExtentions[objIndex].Value);
    }
  }

  public SetImageExtensionOnAdd() {
    this.ImageExtArray.push(".JPG");
    this.ImageExtArray.push(".JPEG");
    this.ImageExtArray.push(".PNG");

    var jpegobjIndex = this.damageImageExtentions.findIndex(
      (x: any) => x.Value == ".JPEG"
    );
    var jpgobjIndex = this.damageImageExtentions.findIndex(
      (x: any) => x.Value == ".JPG"
    );
    var pngobjIndex = this.damageImageExtentions.findIndex(
      (x: any) => x.Value == ".PNG"
    );
    this.damageImageExtentions[jpegobjIndex].IsChecked = true;
    this.damageImageExtentions[jpgobjIndex].IsChecked = true;
    this.damageImageExtentions[pngobjIndex].IsChecked = true;
  }

  public OnChangeDamageImageExtension(imageExtension: any, isChecked: any) {
    var objIndex = this.damageImageExtentions.findIndex(
      (x: any) => x.Value == imageExtension.Value
    );
    if (isChecked) {
      this.ImageExtArray.push(imageExtension.Value);
    } else {
      var index = this.ImageExtArray.indexOf(imageExtension.Value);
      if (index > -1) {
        this.ImageExtArray.splice(index, 1);
      }
    }
    this.damageImageExtentions[objIndex].IsChecked = isChecked;
  }

  public JoinAllImageExtension() {
    if (this.ImageExtArray != null && this.ImageExtArray.length > 0)
      this.model.damageImageExtensions = this.ImageExtArray.join(",");
    else this.model.damageImageExtensions = "";
  }

  OnSubmit(forms: any) {
    this.isLoading = true;
    if (this.uploader.queue && this.uploader.queue.length > 0) {
      this.uploader.onBuildItemForm = (fileItem: any, Form: any) => {
        Form.append("instanceFormData", JSON.stringify(this.model));
      };
      var apiresponse: any;
      var status: any;
      this.uploader.onCompleteItem = (
        item: any,
        response: any,
        status: any,
        headers: any
      ) => {
        apiresponse = JSON.parse(response);
        console.log(apiresponse.error);
        this.isLoading = false;
        if (status == 200) {
          if (apiresponse.data == true) {
            this.popupTitle = this.translate.instant('LblSuccess');
            this.popupMsg = this.isEditMode
              ? this.translate.instant("LblRecordUpdatedSuccess", [this.module])
              : this.translate.instant("LblRecordAddedSuccess", [this.module]);
            this.ShowSuccessPopup();
          } else {
            this.errorModel = apiresponse.error;
            this.ClearFileInput();
          }
        }
      };
      this.uploader.uploadAll();
    } else {
      this.JoinAllImageExtension();
      if (this.model.afasToken != null) {
        this.model.afasToken = this.Base64Encode(this.model.afasToken);
      }
      this.instanceService
        .AddNewInstance(
          "instanceFormData=" + encodeURIComponent(JSON.stringify(this.model))
        )
        .subscribe(
          res => {
            if (res.data) {
              this.popupMsg = this.isEditMode
                ? this.translate.instant("LblRecordUpdatedSuccess", [
                  this.module
                ])
                : this.translate.instant("LblRecordAddedSuccess", [
                  this.module
                ]);
              this.popupTitle = this.translate.instant('LblSuccess');
              this.ShowSuccessPopup();
              this.isLoading = false;
            } else {
              this.errorModel = res.error;
              this.isLoading = false;
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
    }
  }

  public HasModelError(key: string) {
    if (this.errorModel != undefined) {
      let errorMsg = this.errorModel.find(
        item => item.key.toLowerCase() == key.toLowerCase()
      );
      if (errorMsg) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {

    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ShowTwoFaPopup(): void {
    this.TwoFasuccessPopup.show();
  }

  public ConfirmTwoFaPopup(): void {
    this.TwoFasuccessPopup.hide();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public onConfirm($event: any) {
    this.model.geofenceAttributeModel.address = $event.address;
    this.model.geofenceAttributeModel.latitude = $event.lat;
    this.model.geofenceAttributeModel.longitude = $event.long;
  }

  public ResetLocationField() {
    this.model.geofenceAttributeModel.address = "";
    this.model.geofenceAttributeModel.latitude = "0";
    this.model.geofenceAttributeModel.longitude = "0";
  }

  // TODO: Remove this when we're done
  get diagnostic() {
    return JSON.stringify(this.model);
  }

  public GetImageURL(imagePath: string) {
    return WeGoConfig.API_SERVER_URL + imagePath;
  }

  public GetCustomerList() {
    this.customerService.GetCustomerDropdownList().subscribe(
      res => {
        this.apiResponse = res;
        this.customerList = res.data;

        if (this.customerList && this.customerList.length > 0) {
          if (
            !this.model.customerMasterHashId &&
            this.customerList.length == 1
          ) {
            this.model.customerMasterHashId = this.customerList[0].keyHash;
          }
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetTimeZoneList() {
    this.instanceService.GetDropdownTimeZoneList().subscribe(
      res => {
        this.timeZoneList = res.data;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetTelephoneCountry() {
    this.authService.GetTelephoneCountry().subscribe(
      res => {
        this.countryList = res.data;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public ClearFileInput() {
    console.log(this.logoFile);
    if (this.logoFile.nativeElement) {
      console.log(this.logoFile.nativeElement.value);
      this.logoFile.nativeElement.value = "";
      this.uploader.clearQueue();
    }
  }

  // Dashboard configuration function

  private DashboardEnableCurrentLocationChange() {
    if (!this.model.dashboardConfigModel.enableCurrentLocation) {
      this.model.dashboardConfigModel.defaultLocation = "HOME";
      this.model.dashboardConfigModel.enableAutoUpdate = false;
      this.DashboardEnableAutoUpdateChange();
    }
  }

  private DashboardEnableAutoUpdateChange() {
    if (!this.model.dashboardConfigModel.enableAutoUpdate) {
      this.model.dashboardConfigModel.updateIntervalInSecond = "";
    } else {
      this.model.dashboardConfigModel.updateIntervalInSecond = "15";
    }
  }

  private BatchUploadValidateLicenceChange() {
    if (this.model.validateLiceanceNumber) {
      this.model.batchUploadPersonConfigurationModel.sendActivationMail = true;
      this.model.batchUploadPersonConfigurationModel.generateRandom_UseUploadedPassword = true;
      this.model.batchUploadPersonConfigurationModel.fieldPassword = false;
      this.BatchUploadSendActivationMail();
    }
  }

  private ValidateLicense24IDCheckChange() {
    if (this.model.validateLicense24IDCheck != ValidateLicense24IdCheckOption.On) {
      this.model.validateLicenseCheckForBooking = false
    }
  }

  private BatchUploadSendActivationMail() {
    if (this.model.batchUploadPersonConfigurationModel.sendActivationMail) {
      this.model.batchUploadPersonConfigurationModel.generateRandom_UseUploadedPassword = true;
      this.model.batchUploadPersonConfigurationModel.fieldPassword = false;
    }
  }

  private UpdatePriorityNA(issueType: string) {
    switch (issueType) {
      case "DamageReported":
        this.ResetNotificationModel(this.model.reportDamageNotificationModel);
        break;
      case "APKMaintananceScheduled":
        this.ResetNotificationModel(this.model.apkMaintenanceNotificationModel);
        break;
      case "OutSideGeofence":
        this.ResetNotificationModel(this.model.geofenceNotificationModel);
        break;
      case "VehicleSamePosition":
        this.ResetNotificationModel(
          this.model.vehicleSameLocationNotificationModel
        );
        break;
      case "VehicleNotReturn":
        this.ResetNotificationModel(
          this.model.vehicleNotReturnNotificationModel
        );
        break;
      case "VehicleNotBooked":
        this.ResetNotificationModel(
          this.model.vehicleNotBookedNotificationModel
        );
        break;
      case "CleaningRequired":
        this.ResetNotificationModel(
          this.model.cleaningRequiredNotificationModel
        );
        break;
      case "RefuelingRequired":
        this.ResetNotificationModel(
          this.model.refuelingRequiredNotificationModel
        );
        break;
      case "LowBattery":
        this.ResetNotificationModel(this.model.lowBatteryNotificationModel);
        break;
      case "LowCharge":
        this.ResetNotificationModel(this.model.lowChargeNotificationModel);
        break;
      case "CommunicationProblem":
        this.ResetNotificationModel(
          this.model.communicationProblemNotificationModel
        );
        break;
      case "InvalidTagUsed":
        this.ResetNotificationModel(this.model.invalidTagScansNotificationModel);
        break;        
      default:
        break;
    }
  }

  private ResetNotificationModel(notificationModel: InstanceNotificationModel) {
    notificationModel.isEmailEnabled = false;
    notificationModel.isNotificationEnabled = false;
    // notificationModel.weGoAdmin = false;
    // notificationModel.companyAdmin = false;
    // notificationModel.groupAdmin = false;
    // notificationModel.currentDriver = false;
    // notificationModel.nextDriver = false;
  }

  get isGeofenceNotificationDisable() {
    if (!this.model.isGefenceEnabled) {
      this.model.geofenceNotificationModel.priority = "NA";
      this.UpdatePriorityNA("OutSideGeofence");
      return true;
    }
    return false;
  }

  get isReturnToHomeNotificationDisable() {
    if (!(this.model.locationMode == "HOME")) {
      this.model.vehicleNotReturnNotificationModel.priority = "NA";
      this.UpdatePriorityNA("VehicleNotReturn");
      return true;
    }
    return false;
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  onlyNumberKey(event: any) {
    return event.charCode == 8 || event.charCode == 0
      ? null
      : event.charCode >= 48 && event.charCode <= 57;
  }

  changeOfOdometerTimeInterval() {
    if (this.model.odometerConfigurationModel.timeInterval == "PERBOOKING")
      this.model.odometerConfigurationModel.frequency = "";
  }

  public OnVatSetting($event: any) {
    this.model.vatSettingsList = $event.vatSettingsList;
    this.model.vatSettingDefaultCost = $event.vatSettingDefaultCost;
  }

  public OnPrePostTripQuestionSetting($event: any) {
    this.model.customTripQuestionList = $event.customTripQuestionList;
  }

  public ResetCookies() {
    this.isLoading = true;
    this.instanceService.ResetTwoFaCookies(this.instanceHashId)
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.popupTitle = this.translate.instant('LblSuccess');
            this.popupMsg = this.translate.instant('LblCookieResetSuccess', [this.module]);
            this.isLoading = false;
            this.ShowTwoFaPopup();
          }
          else {
            this.popupTitle = this.translate.instant('LblError');
            this.popupMsg = this.translate.instant('LblCookieResetFailed');
            this.isLoading = false;
            this.ShowTwoFaPopup();
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  public ResetTwoFA() {
    this.isLoading = true;
    this.instanceService.ResetTwoFaKeys(this.instanceHashId)
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.popupTitle = this.translate.instant('LblSuccess');
            this.popupMsg = this.translate.instant('LblKeyResetSuccess', [this.module]);
            this.isLoading = false;
            this.ShowTwoFaPopup();
          }
          else {
            this.popupTitle = this.translate.instant('LblError');
            this.popupMsg = this.translate.instant('LblKeyResetFailed');
            this.isLoading = false;
            this.ShowTwoFaPopup();
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  public IsAuthorizedForPrePostTripQuestion() {
    let primaryPermissionType: string;
    let entity: string = '';
    let entityHashId: string = '';
    let permissionType: string = '';
    if (this.instanceHashId != "") {
      primaryPermissionType = PermissionType.EDIT;
      entity = Entity.INSTANCE;
      entityHashId = this.instanceHashId;
    } else {
      primaryPermissionType = PermissionType.INSERT;
      entity = Entity.CUSTOMER;
      entityHashId = this.model.customerMasterHashId;
    }
    this.authService
      .IsAuthorizedForPrePostQuestion(
        Permission.PR_INSTANCE,
        primaryPermissionType,
        Permission.PR_PREPOST_TRIP_QUESTIONS_UPDATE,
        PermissionType.VIEW,
        entity,
        entityHashId
      )
      .subscribe(
        res => {
          this.isAuthorizedForPrePostTrip = res.data.view;
          this.basePermissionModel = res.data;
          console.log(this.prePostTripQuestionSection);
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
        },
        () => {
          setTimeout(() => {
            if (this.isAuthorizedForPrePostTrip) {
              this.prePostTripQuestionSection.GetPrePostTripQuestionList(
                this.instanceHashId,
                null,
                null,
                null,
                this.basePermissionModel,
                !this.instanceHashId,
                true
              );
            }
          }, 1000);
        }
      );
  }

  onChangeSelectedSVG(selectedSvg: any) {
    this.model.defaultSsoSharedVehicleGroupHashId = selectedSvg;
    this.GetOrganizationList();    
  }

  onChangeSelectedOrg(selectedOrg: any) {
    this.model.defaultSsoOrganizationHashId = selectedOrg;
    this.GetSubscriptionList();    
  }
 
  public GetSharedVehicleGroupList() {
    if (this.instanceHashId) {
      this.instanceService.GetSharedVehicleGroupList(this.instanceHashId).subscribe(
        res => {
          this.sharedVehicleGroupList = res.data;
          this.isSvgSelected = this.sharedVehicleGroupList && this.sharedVehicleGroupList.length > 0;

          if (res.error) {
            this.apiSvgErrorMsg = res.error;
            this.isSvgSelected = false;
          } else {
            this.apiSvgErrorMsg = '';
          }
        },
        error => {
          this.apiSvgErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
    } else {
      this.model.defaultSsoSharedVehicleGroupHashId = '';
      this.onChangeSelectedSVG(this.model.defaultSsoSharedVehicleGroupHashId);
      this.isSvgSelected = false;
    }
  }

  public GetOrganizationList() {
    if (this.instanceHashId && this.model.defaultSsoSharedVehicleGroupHashId) {
      this.instanceService.GetOrganizationListBySharedVehicleGroup(this.instanceHashId, this.model.defaultSsoSharedVehicleGroupHashId).subscribe(
        res => {
          this.organizationList = res.data;
          if (this.organizationList && this.organizationList.length > 0) {
            this.isOrgSelected = true;
            if (this.organizationList.length == 1) {
              this.organizationHashID = this.organizationList[0].keyHash;
              this.onChangeSelectedOrg(this.organizationHashID);
            } else {
              this.organizationHashID = '';
            }
          } else {
            this.isOrgSelected = false;
            this.organizationHashID = '';
          }
          
          if (res.error) {
            this.apiOrgErrorMsg = res.error;
            this.isOrgSelected = false;
          } else {
            this.apiOrgErrorMsg = '';
          }
        },
        error => {
          this.apiOrgErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
    } else {
      this.model.defaultSsoOrganizationHashId = '';
      this.onChangeSelectedOrg(this.model.defaultSsoOrganizationHashId);
      this.isOrgSelected = false;
    }
  }

  public GetSubscriptionList() {
    if (this.model.defaultSsoOrganizationHashId) {
      this.instanceService.GetSubscriptionListByOrganization(this.model.defaultSsoOrganizationHashId).subscribe(
        res => {
          this.subscriptionList = res.data;
          if (this.subscriptionList && this.subscriptionList.length > 0) {
            this.subscriptionList.length == 1 ? this.subscriptionHashID = this.subscriptionList[0].subscriptionMapHashId : this.subscriptionHashID = '';
          } 
          res.error ? this.apiSubErrorMsg = res.error : this.apiSubErrorMsg = '';
        },
        error => {
          this.apiSubErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
    } else {
      this.model.defaultSsoSubscriptionHashId = '';
    }
  }

  public Base64Encode(input: string) {
    const encode = Buffer.from(input, 'binary').toString('base64');
    return encode;
  }

  public Base64Decode(input: string) {
    const decode = Buffer.from(input, 'base64').toString('binary');
    return decode;
  }

  public onSubmitClick() {
    if (this.model.importConnectionType == 1) {
      // Afas
      let isValid = true;
      let afasClientIdValue = (<HTMLInputElement>document.getElementById("afasClientId")).value;
      if (!afasClientIdValue) {
        isValid = false;
        (<HTMLInputElement>document.getElementById("afasClientIdError")).innerText = this.translate.instant('LblAfasClientIdError');
      }

      let afasConnectorNameValue = (<HTMLInputElement>document.getElementById("afasConnectorName")).value;
      if (!afasConnectorNameValue) {
        isValid = false;
        (<HTMLInputElement>document.getElementById("afasConnectorNameError")).innerText = this.translate.instant('LblAfasConnectorNameError');
      }
      
      let afasConnectionTypeValue = (<HTMLInputElement>document.getElementById("afasConnectionType")).value;
      if (!afasConnectionTypeValue) {
        isValid = false;
        (<HTMLInputElement>document.getElementById("afasConnectionTypeError")).innerText = this.translate.instant('LblAfasConnectionTypeError');
      }
      
      let afasTokenValue = (<HTMLInputElement>document.getElementById("afasToken")).value;
      if (!afasTokenValue) {
        isValid = false;
        (<HTMLInputElement>document.getElementById("afasTokenError")).innerText = this.translate.instant('LblAfasTokenError');
      }

      return isValid;
    }
    else if (this.model.importConnectionType == 2) {
      // Azure
      let isValid = true;

      let azureTenantIdValue = (<HTMLInputElement>document.getElementById("azureTenantId")).value;
      if (!azureTenantIdValue) {
        isValid = false;
        (<HTMLInputElement>document.getElementById("azureTenantIdError")).innerText = this.translate.instant('LblAzureTenantIdError');
      }

      let azureClientIdValue = (<HTMLInputElement>document.getElementById("azureClientId")).value;
      if (!azureClientIdValue) {
        isValid = false;
        (<HTMLInputElement>document.getElementById("azureClientIdError")).innerText = this.translate.instant('LblAzureClientIdError');
      }

      let azureClientSecretValue = (<HTMLInputElement>document.getElementById("azureClientSecret")).value;
      if (!azureClientSecretValue) {
        isValid = false;
        (<HTMLInputElement>document.getElementById("azureClientSecretError")).innerText = this.translate.instant('LblAzureClientSecretError');
        return false;
      }

      return isValid;
    }
  }  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/instance/components/instance-update.component.ts